import styled from 'styled-components';

export const GtinContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .act-buttons {
    display: flex;
    align-items: center;
    justify-content: center;

    margin-top: 30px;
    gap: 3px;
    margin-left: 3px;

    button {
      border: none;
      background-color: #9900ff;
      padding: 8px;

      border-radius: 5px;

      svg {
        color: white;
      }

      &:disabled {
        opacity: 80%;
        cursor: not-allowed;
      }
    }
  }
`;
